<template>
  <v-container v-if="user">
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Queues</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog width="500" v-model="dialog">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="secondary"
              v-if="user.permissions.admin"
              v-bind="attrs"
              v-on="on"
              small
              fab
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-toolbar dark color="primary">
              <v-toolbar-title>Add Queue</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-form>
                <v-text-field
                  label="Name"
                  v-model="newQueueName"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="addQueue()">Add</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="4" v-for="(queue, index) in queues" :key="index">
            <singleQueue
              v-if="queue && agents && slackMap"
              :queue="queue"
              :agents="agents"
              :slackMap="slackMap"
              @refreshRequest="getData()"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-snackbar v-model="snackbar" :timeout="3000" :color="snackbarColor">
      <v-icon class="mr-2">{{ snackbarIcon }}</v-icon>
      {{ snackbarText }}</v-snackbar
    >
  </v-container>
</template>

<script>
import axios from "@/plugins/axios";
import singleQueue from "@/components/queues/singleQueue.vue";
export default {
  components: {
    singleQueue,
  },
  data() {
    return {
      queues: [],
      agents: [],
      dialog: false,
      slackMap: {},
      user: {},
      newQueueName: "",
      snackbar: false,
      snackbarColor: "",
      interval: undefined,
      snackbarIcon: "",
      snackbarText: "",
    };
  },
  methods: {
    getData() {
      axios.get("/api/v1/queues/list").then((res) => {
        this.queues = res.data;
      });
      axios.get("/api/v1/agents/list").then((res) => {
        this.slackMap = res.data.slackMap;
        this.agents = res.data.ungrouped;
      });
    },
    addQueue() {
      axios
        .post("/api/v1/queues/create", {
          name: this.newQueueName,
        })
        .then(() => {
          this.getData();
          this.dialog = false;
          this.newQueueName = "";
          this.snackbar = true;
          this.snackbarColor = "success";
          this.snackbarIcon = "mdi-check";
          this.snackbarText = "Queue created";
        })
        .catch((err) => {
          this.snackbar = true;
          this.snackbarColor = "error";
          this.snackbarIcon = "mdi-alert";
          this.snackbarText = err.response.data;
        });
    },
  },
  mounted() {
    this.getData();
    this.interval = setInterval(this.getData, 10000);
    this.user = JSON.parse(localStorage.user);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style lang="scss" scoped></style>
